export default {
    'Welcome!': '¡Bienvenido!',
};